import { observer } from 'mobx-react';
import dynamic from 'next/dynamic';

import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';
import { PlpTypes } from 'lib/apis/services/PlpListing';
import Link from "next/link";
import { FiMap } from "react-icons/fi";
import { useGlobalStore } from '../../../../../../lib/DataStore';
import Maybe from '../../../../../elements/maybe';
import { usePlpStore } from '../../../DataStore';
import FilterBoxItems from './FilterBoxItem';
import FilterBoxMobxWrapper from './FilterBoxMobxWrapper';
import FilterBoxWrapper from './FilterBoxWrapper';
import { toast } from 'react-toastify';
const SaveSearch = dynamic(import('./SaveSearch'), { ssr: false });
const LocationSearchInput = dynamic(import('components/elements/searchBox/locationSearchInput'), { ssr: false });

// const LocationField = dynamic(import('./locationField'), { ssr: false });

function Filterbox() {
  const submitHandler = (data: NewPlpTypes.DecodeUrlResultType) => {
    return;
  };

  const { describeLocations, setDescribeLocation, setData, filterData } = usePlpStore();
  let city: Partial<PlpTypes.DescribedLocationV2>[] = describeLocations ? describeLocations.filter(item => item.type === 'city') : [],
    regions: Partial<PlpTypes.DescribedLocationV2>[] = describeLocations ? describeLocations.filter(item => item.type === 'region') : [];

  const changeLocation = (data: Partial<PlpTypes.DescribedLocationV2>[]) => {
    {/* eslint-disable-next-line no-prototype-builtins */ }
    const changeCity = data.filter(item => item.hasOwnProperty('haveRegion')).map(item => ({ ...item, type: "city" }));
    {/* eslint-disable-next-line no-prototype-builtins */ }
    const changeRegions = data.filter(item => !item.hasOwnProperty('haveRegion')).map(item => ({ ...item, type: "region" }));
    let finalLocation: Partial<PlpTypes.DescribedLocationV2>[] | [] = [];
    if (changeCity?.length) {
      finalLocation = changeCity;
    }
    if (changeRegions?.length) {
      finalLocation = [...finalLocation, ...changeRegions];
    }
    if(changeCity?.length > 0) {
      filterData.city = changeCity[0].id;
      filterData.region_IN = changeRegions.map(item =>
        typeof item === 'number' ? item : (item && item.id !== undefined) ? +item.id : '',
      ).join(',');
      setData(filterData, 'FilterBoxItem.tsx');
      setDescribeLocation(finalLocation);
    }
    else {
      toast.error('شهری انتخاب نشده است');
    }
  }
  const { userDevice } = useGlobalStore()

  return (
    <FilterBoxWrapper submitHandler={submitHandler}>
      <div className="flex max-w-5xl relative space-x-4 rtl:space-x-reverse">
        {/*<LocationField name="location"/>*/}
        <Maybe condition={userDevice === 'DESKTOP'}>
          <div className='w-[55%]'>
            <LocationSearchInput onLocationSelected={changeLocation} city={city[0]} regions={regions}
              name={'filterBox'} />
          </div>
        </Maybe>
        <SaveSearch />
        <div className="hidden md:flex md:visible items-center justify-center text-primary-500 px-2 py-1 rounded-md">
          <Link href="https://kilid.com/map/" target="_blank" prefetch={false}>
            <a target="_blank" className="items-center justify-center flex">
              <FiMap size={20} />
              <div className="mr-1">جستجو روی نقشه</div>
            </a>
          </Link>
        </div>
      </div>
      <FilterBoxMobxWrapper location={describeLocations}>
        <FilterBoxItems />
      </FilterBoxMobxWrapper>
    </FilterBoxWrapper>
  );
}

export default observer(Filterbox);
